import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet, AloDbFleetFormation, isAloDbFleetFormation, isAloDbFleetFree } from '@/models/alodb/AloDbFleet'
import FleetGliderAssociationRow from '@/components/fleet/FleetGliderAssociationRow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetFreeGlider',
  setup(__props) {

const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleet)

const onlyOnGoing = ref(false)

const associations = ref<{ key: string; gliKey: string | null; misId: number | null; offsets?: [number, number] }[]>([])

function genereAssociation() {
  associations.value = modified.value.param.freeMissionIds?.map((id, idx) => {
    const mis = store.myGetters.missionsById[id]
    return {
      key: `GLIDER${idx + 1}`,
      gliKey: mis?.gliKey?.trim() ?? null,
      misId: mis?.misId ?? id
    }
  })
  modified.value.param.freeMissionIds = associations.value
    .map((asso) => asso.misId!)
    .filter((id) => id != null) as number[]
}

function removeAsso(idx: number) {
  if (!isAloDbFleetFree(modified.value)) return
  associations.value.splice(idx, 1)
  associations.value.forEach((asso, i) => {
    asso.key = `GLIDER${i + 1}`
  })
}

genereAssociation()

function addGlider() {
  if (!isAloDbFleetFree(modified.value)) return
  console.log('addGlider')
  const nextIdx = associations.value.length + 1
  associations.value.push({ key: `GLIDER${nextIdx}`, gliKey: null, misId: null })
}

watch(() => modified.value.FLE_ID, genereAssociation)

watch(
  associations,
  () => {
    modified.value.param.freeMissionIds = associations.value
      .map((asso) => asso.misId!)
      .filter((id) => id != null) as number[]
  },
  { deep: true }
)

return { __sfc: true,modified, onlyOnGoing, associations, genereAssociation, removeAsso, addGlider, isAloDbFleetFree, FleetGliderAssociationRow }
}

})